<script lang="ts">
  import { slide } from "svelte/transition"
  import Layout from "$app/Layouts/Onboarding.svelte"
  import { Pulse } from "svelte-loading-spinners"
  import Welcome from "./Onboarding/Welcome.svelte"
  import YourProfile from "./Onboarding/YourProfile.svelte"
  import OnePageView from "./Onboarding/OnePageView.svelte"
  import Resources from "./Onboarding/Resources.svelte"
  import Activity from "./Onboarding/Activity.svelte"
  import Recognitions from "./Onboarding/Recognitions.svelte"
  import MobileApp from "./Onboarding/MobileApp.svelte"
  import { appStore } from "$app/store.svelte"

  let props = $props()
  let user: UserType = props.user
  let plan: PlanType = props.plan
  let role: string = props.role
  let end_of_year: string = props.end_of_year

  appStore.current_user = user
  appStore.plan = plan
  appStore.role = role
  appStore.end_of_year = end_of_year

  let current_onboarding_step = $state(user.current_onboarding_step.standard)
  if (role === "recognition") {
    current_onboarding_step = user.current_onboarding_step.recognition
  }

  function updateUser(user) {
    current_onboarding_step = user.current_onboarding_step.standard
    if (role === "recognition") {
      current_onboarding_step = user.current_onboarding_step.recognition
    }

    if (user.onboarding_completed_at) {
      window.location.href = "/plans"
    }
  }

  function updateStep(step) {
    user.current_onboarding_step = step
  }
</script>

<Layout {...props}>
  {#if current_onboarding_step === "welcome"}
    <div transition:slide>
      <Welcome onUpdateUser={updateUser} onUpdateStep={updateStep} />
    </div>
  {:else if current_onboarding_step === "your_profile"}
    <div transition:slide>
      <YourProfile onUpdateUser={updateUser} onUpdateStep={updateStep} />
    </div>
  {:else if current_onboarding_step === "one_page_view"}
    <div transition:slide>
      <OnePageView onUpdateUser={updateUser} onUpdateStep={updateStep} />
    </div>
  {:else if current_onboarding_step === "activity"}
    <div transition:slide>
      <Activity onUpdateUser={updateUser} onUpdateStep={updateStep} />
    </div>
  {:else if current_onboarding_step === "recognitions"}
    <div transition:slide>
      <Recognitions onUpdateUser={updateUser} onUpdateStep={updateStep} />
    </div>
  {:else if current_onboarding_step === "mobile_app"}
    <div transition:slide>
      <MobileApp onUpdateUser={updateUser} onUpdateStep={updateStep} />
    </div>
  {:else if current_onboarding_step === "resources"}
    <div transition:slide>
      <Resources onUpdateUser={updateUser} onUpdateStep={updateStep} />
    </div>
  {:else}
    <div class="mx-auto px-6 pt-4 w-full bg-lwp-pale-grey h-screen">
      <div class="py-12 flex justify-center w-full">
        <Pulse size="300" color="#cdcdcd" unit="px" duration="1s" />
      </div>
    </div>
  {/if}
</Layout>
